/**
 * Open RACI obligations ID-list (§7.14 / SCOPING_ONBOARDING_FLOW — Track 4
 * Slice A). Lightweight, user-scoped list of the caller's open Responsible
 * Gantt tasks, consumed by the app-wide Action Center badge composer so the
 * badge can count RACI obligations without the per-project Gantt fan-out the
 * inbox performs on AC mount (useMyRaciTasks stays the list's source).
 *
 * The item KEY built here must stay byte-identical to the id produced by
 * raciTaskToActionItem (`raci:{project}:{slot}:{task}`, uppercase) so the
 * shared seen/resolved predicate applies to both. Acceptance guard: the
 * badge's RACI ids ⊆ the inbox's RACI items on AC mount.
 */

import { apiFetch } from "./client";

export interface OpenRaciItem {
  taskGuid: string;
  projectGuid: string;
  roleSlotGuid: string;
  taskName: string;
  startDate: string | null;
  endDate: string | null;
  percentComplete: number;
}

export async function fetchOpenRaciItems(): Promise<OpenRaciItem[]> {
  return apiFetch<OpenRaciItem[]>("/api/action-items/raci-open");
}

/** The inbox's RACI item id scheme — keep in lockstep with raciTaskToActionItem. */
export function openRaciItemKey(r: OpenRaciItem): string {
  return `raci:${r.projectGuid}:${r.roleSlotGuid}:${r.taskGuid}`.toUpperCase();
}
